export default __webpack_public_path__ + "static/media/shahbaz.9819a45f.jpg";